module.exports = __webpack_public_path__ + "static/whoweare-d52dd9caeda6a24db1998827ada5af49.jpg";